import React from "react";

const ResetFiltersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        d="M48.3333 11.2963L41.6188 7.56596C40.6121 7.00666 39.3879 7.00666 38.3812 7.56596L31.6667 11.2963M61.6667 18.7037L68.2855 22.3808C69.3437 22.9687 70 24.0841 70 25.2946V31.6666M70 48.3333V54.7053C70 55.9158 69.3437 57.0312 68.2855 57.6191L61.6667 61.2963M48.3333 68.7037L41.6188 72.4339C40.6121 72.9933 39.3879 72.9933 38.3812 72.4339L31.6667 68.7037M18.3333 61.2963L11.7145 57.6191C10.6563 57.0312 10 55.9158 10 54.7053V48.3333M10 31.6666V25.2946C10 24.0841 10.6563 22.9687 11.7145 22.3808L18.3333 18.7037"
        stroke="url(#paint0_linear_528_30404)"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_528_30404"
          x1="10"
          y1="7.14648"
          x2="75.4366"
          y2="66.8997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ResetFiltersIcon;
